package migrations

import kotlin.Long
import kotlin.String

public data class InspectionTable(
  public val id: String,
  public val templateId: String,
  public val templateName: String,
  public val vesselName: String?,
  public val totalAnswer: Long,
  public val totalQuestion: Long,
  public val lastUpdated: String,
  public val status: String,
  public val userId: String,
  public val conducted: String?,
)
